import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    createWarehouse (payload) {
        return httpService.post(ApiEndpoints.get('warehouse'), payload);
    },
    updateWarehouse (payload) {
        return httpService.put(
            ApiEndpoints.get('single_warehouse', { warehouseId: payload.id }),
            payload.data
        );
    },
    postWarehouseDraft (id, data) {
        return httpService.post(ApiEndpoints.get('warehouse_draft', { warehouseWioStructId: id }), data);
    },
    getWarehouseDraft (id) {
        return httpService.get(ApiEndpoints.get('warehouse_draft', { warehouseWioStructId: id }));
    },
    removeWarehouseDraft (id) {
        return httpService.delete(ApiEndpoints.get('warehouse_draft', { warehouseWioStructId: id }));
    },
    getFamiliesPerWarehouse (data) {
        return httpService.get(
            ApiEndpoints.get('families_per_warehouse', { warehouseId: data.warehouseId }),
            {
                params: data.params
            }
        );
    },
    getWarehouseExistInfo (id) {
        return httpService.get(ApiEndpoints.get('warehouse_exist', { wioStructId: id }));
    },
    acceptWarehouse (warehouseId) {
        return httpService.put(ApiEndpoints.get('accept_warehouse', { warehouseId }));
    },
    getWarehousesPerLocation (id) {
        return httpService.get(ApiEndpoints.get('warehouses_per_location', { wioStructId: id }));
    },
    getWarehouseManagers (data) {
        return httpService.get(
            ApiEndpoints.get('warehouse_manager_list', {
                wioStructId: data.wioStructId,
                warehouseType: data.warehouseType
            })
        );
    },
    getWarehouse (data) {
        return httpService.get(
            ApiEndpoints.get('single_warehouse', { warehouseId: data.warehouseId }),
            { params: data.params }
        );
    },
    getAllAvailableWarehouses (data) {
        return httpService.get(ApiEndpoints.get('warehouse'), {
            params: data
        });
    }
};
